import actions from '../../actionTypes';

export default user => {
  return {
    type: actions.EDIT_USER,
    user
  };
};



// WEBPACK FOOTER //
// ./src/reducers/users/actions/editUser.js